import React, { useEffect } from "react";
import banner from "../../../../assets/Banners/banner_netuno-gracias.png";
import ButtonGeneric from "../../../../components/Buttons/ButtonGeneric";
import { UseContextApp } from "../../../../Global/Context/appContext";
import { PaperClipIcon, CreditCardIcon } from '@heroicons/react/solid'
import StepsGeneric from "../../../../components/Nav/StepsGeneric";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function BanescoConfirmation({ }) {

    const navigate = useNavigate();
    const [{ user }] = UseContextApp()

    const home = () => {
        navigate("/cuenta/dashboard");
    };    

    const [email, setEmail] = useState({
        numero: localStorage.getItem('email')
    })

    const [cuenta, setCuenta] = useState({
        numero: localStorage.getItem('nrm')
    })
    const [transaction, setTransaction] = useState({
        numero: localStorage.getItem('transaction')
    })

    const [monto, setMonto] = useState({
        numero: localStorage.getItem('monto')
    })

    const [fecha, setFecha] = useState({
        numero: localStorage.getItem('fecha')
    })
    const atras = () => {
        navigate('/cuenta/pagos')
    }
    const Print = () => {

        let printContents = document.getElementById('print-mount').innerHTML;
        let originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        document.body.innerHTML = originalContents;
    }

    return (
        <div className=" relative bg-[#f3f4f6]">
            <div className="flex max-w-7xl mx-auto  pt-6 justify-center">
                <div className="flex w-full lg:w-full px-4 pt-5 gap-5 flex-col">
 
                    <div className="bg-white  rounded-md shadow mb-[100px]">
                        <div className=" flex justify-center items-center flex-col gap-6 ">
                            <div className="w-full flex-col flex gap-5">
                                <div className="bg-white w-full px-4 py-5 border-b border-gray-200 sm:px-6">
                                    <div className="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
                                        <div className="ml-4 mt-4">
                                            <h3 className="text-2xl leading-6 font-medium text-gray-900">
                                                Confirmación
                                            </h3>
                                            <p className="mt-1 text-sm text-gray-500">Confirmación de pago</p>
                                        </div>
                                    </div>
                                </div>
                                <main className="bg-white px-4  md:pb-0 sm:px-6 sm:pt-24 md:px-0 md:py-0">
                                <div id="print-mount" className="pl-5 flex flex-col gap-4 mx-auto">
                                    <div className="pl-5 flex flex-col gap-4 mx-auto">
                                        <div className="w-full flex justify-center items-center rounded-md  pt-5">
                                            <img className="w-[50%] object-contain h-[400px] " src={banner} alt="" />
                                        </div>
                                      
                                            <div className="grid place-content-center pla">
                                                <div className="max-w-xl flex flex-col justify-center ">
                                                    <p className="mt-2 text-center text-2xl md:text-4xl font-extrabold tracking-tight sm:text-5xl">
                                                        Pago Recibido
                                                    </p>
                                                    <dl className=" text-center mt-6 md:mt-0 text-sm font-medium">
                                                        Estimado cliente, le informamos que estamos validando la transacción. Concluido el proceso de validación, en el lapso máximo de 1 hora le notificaremos a su dirección de correo electrónico.
                                                    </dl>
                                                    <ul role="list" className="border border-gray-200 mt-4 rounded-md divide-y divide-gray-200">
                                                        <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                            <div className="w-0 flex-1 flex items-center">
                                                                <PaperClipIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                <span className="ml-2 flex-1 w-0 truncate">Email: </span>
                                                            </div>
                                                            <div className="ml-4 flex-shrink-0">
                                                                <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                {email.numero}
                                                                </p>
                                                            </div>
                                                        </li>
                                                        {
                                                            cuenta.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Cuenta: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {cuenta.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            transaction.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Transacción: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {transaction.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            monto.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Monto Bs: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {monto.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }
                                                        {
                                                            fecha.numero &&
                                                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                                                <div className="w-0 flex-1 flex items-center">
                                                                    <CreditCardIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                                                    <span className="ml-2 flex-1 w-0 truncate">Fecha de Transacción: </span>
                                                                </div>
                                                                <div className="ml-4 flex-shrink-0">
                                                                    <p className="font-medium text-[#5ab9e5] hover:text-[#5ab9e5] ">
                                                                        {fecha.numero}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        }

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </main>
                                <div className="w-full flex justify-center   gap-[50%] p-5 ">
                                    <div className="w-[47%] flex justify-between gap-[30px] ml-[20px] ">
                                        <ButtonGeneric funtion={home} text={"Ir al home"} />
                                        <ButtonGeneric funtion={Print} text={"Imprimir"} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
}

export default BanescoConfirmation;
